import React from 'react';
import PropTypes from 'prop-types';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import './AlertIcon.scss';

const AlertIcon = ({ tooltipContent }) => {
  return (
    <span className="alert-icon">
      <InformationBubble
        tooltipContent={tooltipContent}
        id={tooltipContent}
      >
        <svg width="14px" height="12px" viewBox="0 0 13 12" version="1.1" >
          <g id="Case-Details---v2.0" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Case-Details---Expanded-Details" transform="translate(-1372.000000, -862.000000)" fill="#EC9A2F" fillRule="nonzero">
              <g id="More-Details" transform="translate(255.000000, 715.000000)">
                <g id="exclamation-triangle-solid" transform="translate(1117.000000, 147.000000)">
                  <path d="M12.8536851,9.93084907 C13.2702718,10.6529359 12.7473605,11.5555557 11.9153156,11.5555557 L1.08455825,11.5555557 C0.250910913,11.5555557 -0.269585467,10.6515366 0.14618872,9.93084907 L5.5616351,0.541328236 C5.97842491,-0.181097111 7.02232913,-0.179788083 7.43837415,0.541328236 L12.8536851,9.93084907 Z M6.50000462,7.98958344 C5.92662805,7.98958344 5.46181047,8.45440115 5.46181047,9.02777789 C5.46181047,9.60115463 5.92662805,10.0659723 6.50000462,10.0659723 C7.0733812,10.0659723 7.53819877,9.60115463 7.53819877,9.02777789 C7.53819877,8.45440115 7.0733812,7.98958344 6.50000462,7.98958344 Z M5.51432956,4.25781608 L5.68174965,7.32726053 C5.68958124,7.47089247 5.80834163,7.58333344 5.95217665,7.58333344 L7.04783259,7.58333344 C7.19166762,7.58333344 7.31042801,7.47089247 7.3182596,7.32726053 L7.48567969,4.25781608 C7.49414323,4.10267372 7.3706207,3.97222233 7.21525269,3.97222233 L5.78473399,3.97222233 C5.62936598,3.97222233 5.50586602,4.10267372 5.51432956,4.25781608 L5.51432956,4.25781608 Z" id="Shape" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </InformationBubble>
    </span>
  );
};

AlertIcon.props = {
  tooltipContent: PropTypes.string,
};

AlertIcon.defaultProps = {
  tooltipContent: '',
};

export default AlertIcon;
